// pages references that can have many objects table
const PAGE_REFERENCES = {
  ADMIN_TOOLS: "admin_tools",
  ADMIN_TOOLS_FORECASTING: "admin_tools_forecasting",
  ADMIN_TOOLS_GROWTH_MATRIX: "admin_tools_growth_matrix",
  ADMIN_TOOLS_TEMPLATES: "admin_tools_templates",
  ADMIN_TOOLS_THEMES: "admin_tools_themes",
  ADMIN_TOOLS_NOTIFICATIONS: "admin_tools_notifications",
  ADMIN_TOOLS_SUGGESTED_LISTS: "admin_tools_suggested_lists",
  ADMIN_TOOLS_ROLES_PERMISSIONS: "admin_tools_roles_permissions",
  ADMIN_TOOLS_MY_ACTIVITIES: "admin_tools_my_activities",

  COMPANY_PROFILE: "company_profile",
  COMPANY_PROFILE_ACTIONS_INTERACTIONS: "company_profile_actions_interactions",
  COMPANY_PROFILE_CHECKLISTS: "company_profile_checklists",
  COMPANY_PROFILE_COMPANY_MAP: "company_profile_company_map",
  COMPANY_PROFILE_INSIGHTS: "company_profile_insights",
  COMPANY_PROFILE_OVERVIEW: "company_profile_overview",

  OBJECT_PROFILE: "object_profile",
  OBJECT_PROFILE_ACTIONS_INTERACTIONS: "object_profile_actions_interactions",
  OBJECT_PROFILE_CHECKLISTS: "object_profile_checklists",
  OBJECT_PROFILE_COMPANY_MAP: "object_profile_company_map",
  OBJECT_PROFILE_INSIGHTS: "object_profile_insights",
  OBJECT_PROFILE_OVERVIEW: "object_profile_overview",

  CONTACT_PROFILE: "contact_profile",
  CUSTOMER_JOURNEYS: "customer_journeys",

  HOMEPAGE: "homepage",

  DASHBOARD: "dashboard",
  DASHBOARD_ACTIONS_TABLE: "dashboard_actions_table",
  DASHBOARD_CUSTOMER_JOURNEYS: "dashboard_customer_journeys",
  DASHBOARD_FORECASTING_TABLE: "dashboard_forecasting_table",
  DASHBOARD_LEADS_TABLE: "dashboard_leads_table",
  FORECASTING: "forecasting",
  INTEGRATIONS_DATA: "integrations_data",
  METRICS: "metrics",

  PORTFOLIO: "portfolio",
  WORKSPACE: "workspace",
  PROSPECTING: "prospecting",
  PROSPECTING_EXPANSION_LISTS: "prospecting_expansion_lists",
  PROSPECTING_GROWTH_MATRIX: "prospecting_growth_matrix",
  PROSPECTING_PROSPECT: "prospecting_prospect",
  PROSPECTING_SUGGESTED: "prospecting_suggested",
  SETTINGS: "settings",
  SETTINGS_PASSWORD: "settings_password",
  SETTINGS_PLAN_BILLING: "settings_plan_billing",
  SETTINGS_PROFILE: "settings_profile",

  PLAYBOOK_AUDIT_PAGE: "playbook_audit_page",

  SIGN_OUT: "sign_out",
  SWITCH_TO_DARK_MODE: "switch_to_dark_mode"
}

const LAYOUT_PAGES = {
  COMPANY_PROFILE_ACTIONS_INTERACTIONS: "company_profile_actions_interactions",
  COMPANY_PROFILE_CHECKLISTS: "company_profile_checklists",
  COMPANY_PROFILE_COMPANY_MAP: "company_profile_company_map",
  COMPANY_PROFILE_INSIGHTS: "company_profile_insights",
  COMPANY_PROFILE_OVERVIEW: "company_profile_overview",

  OBJECT_PROFILE_ACTIONS_INTERACTIONS: "object_profile_actions_interactions",
  OBJECT_PROFILE_CHECKLISTS: "object_profile_checklists",
  OBJECT_PROFILE_COMPANY_MAP: "object_profile_company_map",
  OBJECT_PROFILE_INSIGHTS: "object_profile_insights",
  OBJECT_PROFILE_OVERVIEW: "object_profile_overview",

  CUSTOMER_JOURNEYS: "customer_journeys",
  OBJECT_CUSTOMER_JOURNEYS: "customer_journeys",

  DASHBOARD: "dashboard",
  FORECASTING: "forecasting",
  OBJECT_FORECASTING: "forecasting",
  PORTFOLIO: "portfolio",
  WORKSPACE: "workspace",
  OBJECT_PORTFOLIO: "portfolio",
  PROSPECTING_EXPANSION_LISTS: "prospecting_expansion_lists",
  OBJECT_PROSPECTING_EXPANSION_LISTS: "prospecting_expansion_lists",
  PROSPECTING_GROWTH_MATRIX: "prospecting_growth_matrix",
  OBJECT_PROSPECTING_GROWTH_MATRIX: "prospecting_growth_matrix",
  PROSPECTING_PROSPECT: "prospecting_prospect",
  OBJECT_PROSPECTING_PROSPECT: "prospecting_prospect",
  PROSPECTING_SUGGESTED: "prospecting_suggested",
  OBJECT_PROSPECTING_SUGGESTED: "prospecting_suggested"
}

const VIEW_TYPES = {
  TABLE: "table",
  ROLLUPS: "rollups",
  FORM_CREATE: "form_create",
  FORM_UPDATE: "form_update"
}

const MODULES = {
  ADMIN_TOOLS: "rs-admin-tools",
  ADMIN_TOOLS_FORECASTING_PREFERENCES: "rs-admin-tools-forecasting-preferences",
  ADMIN_TOOLS_GROWTH_MATRIX: "rs-admin-tools-growth-matrix",
  ADMIN_TOOLS_NOTIFICATIONS: "rs-admin-tools-notifications",
  ADMIN_TOOLS_ROLES_PERMISSIONS: "rs-admin-tools-roles-permissions",
  ADMIN_TOOLS_MY_ACTIVITIES: "rs-admin-tools-my-activities",
  ADMIN_TOOLS_SUGGESTED_LISTS: "rs-admin-tools-suggested-lists",
  ADMIN_TOOLS_GLOBAL_VARIABLES: "rs-admin-tools-global-variables",
  ADMIN_TOOLS_GLOBAL_SETTINGS: "rs-admin-tools-global-settings",

  COMPANY_PROFILE: "rs-company-profile",
  COMPANY_PROFILE_ACTIONS_INTERACTIONS: "rs-company-profile-actions-interactions",
  COMPANY_PROFILE_CHECKLISTS: "rs-company-profile-checklists",
  COMPANY_PROFILE_COMPANY_MAP: "rs-company-profile-company-map",
  COMPANY_PROFILE_INSIGHTS: "rs-company-profile-insights",
  COMPANY_PROFILE_ALL_INSIGHTS: "rs-company-profile-all-insights",
  COMPANY_PROFILE_OVERVIEW: "rs-company-profile-overview",

  CUSTOMER_JOURNEYS: "rs-customer-journeys",

  DASHBOARD: "rs-dashboard",
  DASHBOARD_ACTIONS_TABLE: "rs-dashboard-actions-table",
  DASHBOARD_CUSTOMER_JOURNEYS: "rs-dashboard-customer-journeys",
  DASHBOARD_FORECASTING_TABLE: "rs-dashboard-forecasting-table",
  DASHBOARD_LEADS_TABLE: "rs-dashboard-leads-table",

  FORECASTING: "rs-forecasting",
  MULTIPLE_FORECASTING_OBJECTS: "rs-forecasting-multiple-forecasting-objects",

  INTEGRATIONS_DATA: "rs-integrations-data",
  METRICS: "rs-metrics",

  PORTFOLIO: "rs-portfolio",

  WORKSPACE: "rs-workspace",

  PROSPECTING: "rs-prospecting",
  PROSPECTING_PROSPECT: "rs-prospecting-prospect",
  PROSPECTING_EXPANSION_LISTS: "rs-prospecting-expansion-lists",
  PROSPECTING_SUGGESTED: "rs-prospecting-suggested",
  PROSPECTING_GROWTH_MATRIX: "rs-prospecting-growth-matrix",

  SETTINGS: "rs-settings",
  SETTINGS_PASSWORD: "rs-settings-password",
  SETTINGS_PLAN_BILLING: "rs-settings-plan-billing",
  SETTINGS_PROFILE: "rs-settings-profile",
  SIGN_OUT: "rs-sign-out",
  SWITCH_TO_DARK_MODE: "rs-switch-to-dark-mode"
}

const PAGE_REFERENCES_MODULES = {
  admin_tools: "rs-admin-tools",
  admin_tools_forecasting: "rs-admin-tools-forecasting-preferences",
  admin_tools_growth_matrix: "rs-admin-tools-growth-matrix",
  admin_tools_notifications: "rs-admin-tools-notifications",
  admin_tools_suggested_lists: "rs-admin-tools-suggested-lists",
  company_profile: "rs-company-profile",
  company_profile_actions_interactions: "rs-company-profile-actions-interactions",
  company_profile_checklists: "rs-company-profile-checklists",
  company_profile_company_map: "rs-company-profile-company-map",
  company_profile_insights: "rs-company-profile-insights",
  company_profile_overview: "rs-company-profile-overview",

  object_profile: "rs-company-profile",
  object_profile_actions_interactions: "rs-company-profile-actions-interactions",
  object_profile_checklists: "rs-company-profile-checklists",
  object_profile_company_map: "rs-company-profile-company-map",
  object_profile_insights: "rs-company-profile-insights",
  object_profile_overview: "rs-company-profile-overview",

  contact_profile: "rs-company-profile",

  homepage: "rs-homepage",

  customer_journeys: "rs-customer-journeys",
  dashboard: "rs-dashboard",
  dashboard_actions_table: "rs-dashboard-actions-table",
  dashboard_customer_journeys: "rs-dashboard-customer-journeys",
  dashboard_forecasting_table: "rs-dashboard-forecasting-table",
  dashboard_leads_table: "rs-dashboard-leads-table",

  forecasting: "rs-forecasting",

  integrations_data: "rs-integrations-data",
  metrics: "rs-metrics",
  portfolio: "rs-portfolio",
  workspace: "rs-workspace",
  prospecting: "rs-prospecting",
  prospecting_expansion_lists: "rs-prospecting-expansion-lists",
  prospecting_growth_matrix: "rs-prospecting-growth-matrix",
  prospecting_prospect: "rs-prospecting-prospect",
  prospecting_suggested: "rs-prospecting-suggested",
  settings: "rs-settings",
  settings_password: "rs-settings-password",
  settings_plan_billing: "rs-settings-plan-billing",
  settings_profile: "rs-settings-profile",
  settings_roles_permissions: "rs-settings-roles-permissions",
  sign_out: "rs-sign-out",
  switch_to_dark_mode: "rs-switch-to-dark-mode"
}

export { PAGE_REFERENCES, VIEW_TYPES, MODULES, PAGE_REFERENCES_MODULES, LAYOUT_PAGES }
